import { inject, runInInjectionContext } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { PlatformService } from 'shared/services/platform/platform.service';

export const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

bootstrapApplication(AppComponent, appConfig)
.then(appRef => {
   // Load services as early as possible
   runInInjectionContext(appRef.injector, () => {
    inject(PlatformService);
  })
})
.catch(error => {
  showErrorLog(error);
})

function showErrorLog(error: any) {
  document.getElementsByTagName('body')[0].innerHTML = `
      <div style="padding:24px">
        <h1>Resparke failed to load because of the following error:</h1>
        <h3>"${error.message}"</h3>
        <pre style="font-weight: 300; text-wrap: inherit; background-color: #E0F3F3; padding: 16px;">${error.stack.toString()}
        </pre>
        <p style="padding: 16px; background-color: #E4C5DC;">If you get this error, please take a picture or screenshot and report it at https://www.resparke.com/support/</p>
      </div>
      `
}

